import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "content" };
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
    key: 1,
    class: "progress is-primary"
};
import { loading_success } from "@/lib/helpers";
import { PublicStore } from "@/lib/store/public";
import { marked } from "marked";
import PitchClaimer from "../camp/PitchClaimer.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'GuestView',
    setup(__props) {
        const store = PublicStore();
        return (_ctx, _cache) => {
            return (_unref(loading_success)(_unref(store).selected_event))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("h3", null, _toDisplayString(_unref(store).selected_event.name), 1),
                        _createElementVNode("p", {
                            class: "has-text-justified",
                            innerHTML: _unref(marked).parse(_unref(store).selected_event.description)
                        }, null, 8, _hoisted_3)
                    ]),
                    _createVNode(PitchClaimer)
                ]))
                : (_openBlock(), _createElementBlock("progress", _hoisted_4));
        };
    }
});
